
<div class="h-100">
    <c-column-header v-if="showHeader" :label="'Katalog - ' + title" class="primary mb-1" :title-border = "true" />

    <div :id="'audit-scroll'+ type" class="scroll-area mt-0 white" @scroll = "onScroll">
        <div v-for="(entry, index) in entries" :key = "'cat_2_' + index"  style="width: calc(100% - 4px)" :id = "'entry-' + entry.catalogue.id">
            <p-audit-escalator-entry
                v-if      = "isEscalator"
                class     = "mb-1"
                :audit-id = "auditId"
                :entry    = "entry"
                :country  = "country"
                :enums    = "enums"
                :editable = "showBudgetData"
            />
            <p-audit-catalog-entry
                v-else
                class             = "mb-1"
                :audit-id         = "auditId"
                :entry            = "entry"
                :unit             = "unit"
                :country          = "country"
                :show-budget-data = "showBudgetData"
            />
        </div>
    </div>
</div>
